export default __webpack_public_path__ + "static/media/helpful-resources-desktop.7ff153d1.webp";